import { FC } from 'react'

import { useRequestTypes } from '@/api/models/requests/hooks/useRequestTypes'
import GoBackButton from '@/components/shared/button/ui/GoBackButton'

type Props = {
  type: string
  onBack: () => void
  hasRepeatParam?: boolean
}

const PassFormTitle: FC<Props> = ({ type, onBack, hasRepeatParam }) => {
  const { data: requestTypes } = useRequestTypes()

  const currentType = requestTypes?.find(
    requestType => requestType.alias === type
  )

  const onBackButtonClick = () => {
    onBack()
  }

  return (
    <div className="flex items-center gap-24">
      {!hasRepeatParam && <GoBackButton onClick={onBackButtonClick} />}
      <span>{currentType?.name}</span>
    </div>
  )
}

export { PassFormTitle }
